import base from './base';
import data from './data/authNJ';

const authNJApi = {};

authNJApi.checkOTP = () => {
  return base.fetch(data.otp, 300);
};

authNJApi.getAuthData = () => {
  console.log('getAuthData', data.authData);
  return base.fetch(data.authData, 300);
};

authNJApi.setAuthData = () => {
  return base.fetch(data.registerAuthDataRes, 300);
};

authNJApi.editAuthData = () => {
  return base.fetch(data.editAuthDataRes, 300);
};

authNJApi.getFileList = () => {
  return base.fetch(data.fileList, 300);
};

authNJApi.uploadFiles = () => {
  return base.fetch(data.uploadFilesRes, 300);
};

export default {
  ...authNJApi,
};
